export default {"src":"/_next/static/media/crosslines.00254079.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};